export const dataMonthInterval = 3;
export const timeTo = new Date();
export const timeFrom = new Date(new Date().setMonth(timeTo.getMonth() - dataMonthInterval));


// export const timeTo = new Date('2022-07-12');
// export const timeFrom = new Date('2022-07-10');